import React, { Component } from 'react'
import { withStyles, withTheme } from '@material-ui/core/styles'
import Moment from 'moment'
import {
  getOptionsDataAndSms,
  getOptionsData,
  getOptionsSms
} from './graph-options'
import Y from '../../../y18n'
import Styles from '../../../common/styles'
import ScrollLine from './scroll-line'

const defaultData = {
  dates: [new Date()],
  dataRemaining: [0]
}
class DataGraph extends Component {
  getDataset (data, sms, themeColor) {
    if (data && sms) {
      return {
        labels: this.props.subscription.data.dates.map(date =>
          new Moment(date).format('YYYY-MM-DD')
        ),
        datasets: [
          {
            label: '(' + Y`Remaining data` + ' (MB',
            backgroundColor: `${themeColor}33`,
            borderColor: themeColor,
            borderWidth: 1,
            pointBackgroundColor: themeColor,
            hoverBackgroundColor: `${themeColor}66`,
            hoverBorderColor: themeColor,
            data: this.props.subscription.data.dataRemaining.map(data =>
              data.toFixed(2)
            ),
            lineTension: 0,
            yAxisID: 'A',
            stack: '1'
          },
          {
            label: Y`SMS usage` + ' (%)',
            backgroundColor: 'rgba(146,190,210, 0.6)',
            borderColor: 'rgba(146,190,210, 0.8)',
            borderWidth: 1,
            pointBackgroundColor: 'rgba(146,190,210, 0.8)',
            hoverBackgroundColor: 'rgba(146,190,210, 0.8)',
            hoverBorderColor: 'rgba(146,190,210, 1)',
            data: this.props.subscription.data.smsPercentage.map(sms =>
              Math.min(100.00, Number(sms * 100).toFixed(2))
            ),
            lineTension: 0,
            yAxisID: 'B',
            stack: '2'
          }
        ]
      }
    } else if (data) {
      return {
        labels: this.props.subscription.data.dates.map(date =>
          new Moment(date).format('YYYY-MM-DD')
        ),
        datasets: [
          {
            label: '(' + Y`Remaining data` + ' (MB',
            backgroundColor: `${themeColor}33`,
            borderColor: themeColor,
            borderWidth: 1,
            pointBackgroundColor: themeColor,
            hoverBackgroundColor: `${themeColor}66`,
            hoverBorderColor: themeColor,
            data: this.props.subscription.data.dataRemaining.map(data =>
              data.toFixed(2)
            ),
            lineTension: 0,
            yAxisID: 'A',
            stack: '1'
          }
        ]
      }
    } else if (sms) {
      return {
        labels: this.props.subscription.data.dates.map(date =>
          new Moment(date).format('YYYY-MM-DD')
        ),
        datasets: [
          {
            label: Y`SMS usage` + ' (%)',
            backgroundColor: 'rgba(146,190,210, 0.6)',
            borderColor: 'rgba(146,190,210, 0.8)',
            borderWidth: 1,
            pointBackgroundColor: 'rgba(146,190,210, 0.8)',
            hoverBackgroundColor: 'rgba(146,190,210, 0.8)',
            hoverBorderColor: 'rgba(146,190,210, 1)',
            data: this.props.subscription.data.smsPercentage.map(sms =>
              data.toFixed(2)
            ),
            lineTension: 0,
            yAxisID: 'A',
            stack: '1'
          }
        ]
      }
    } else {
      return {
        labels: defaultData.dates.map(date =>
          new Moment(date).format('YYYY-MM-DD')
        ),
        datasets: [
          {
            label: '(' + Y`Remaining data` + ' (MB',
            backgroundColor: `${themeColor}33`,
            borderColor: themeColor,
            borderWidth: 1,
            pointBackgroundColor: themeColor,
            hoverBackgroundColor: `${themeColor}66`,
            hoverBorderColor: themeColor,
            data: this.props.subscription.data.dataRemaining.map(data =>
              data.toFixed(2)
            ),
            lineTension: 0
          }
        ]
      }
    }
  }

  render () {
    const { subscription, theme } = this.props
    if (
      subscription.data === undefined ||
      subscription.data.dates === undefined
    ) {
      return null
    }
    const status =
      subscription.data && subscription.data.dataRemaining.length > 0
    const smsStatus =
      subscription.data &&
      subscription.data.smsPercentage &&
      subscription.data.smsPercentage.length > 0
    const dataSet = this.getDataset(
      status,
      smsStatus,
      theme.palette.primary.main
    )
    const options = status && smsStatus
      ? getOptionsDataAndSms()
      : (!status && !smsStatus) || status ? getOptionsData() : getOptionsSms()

    options.animation = {
      duration: 100,
      onComplete: () => this.extractAxes(),
      onProgress: () => this.clearCanvasAxes()
    }

    // options.maintainAspectRatio = false

    // Credits:  Johannes Attentec
  //   let dataSetWithFirstSixHundredDataPoints = (dataSet) => {
  //     const LIBRARY_HARD_LIMIT = 600;
  //     return {
  //         ...dataSet,
  //         labels: dataSet.labels.slice(0, LIBRARY_HARD_LIMIT),
  //         datasets: dataSet.datasets.map(ds => ({ ...ds, data: ds.data.slice(0, LIBRARY_HARD_LIMIT) }))
  //     };
  // }

    if(dataSet.labels.length > 600)
      console.log("ERROR: Datagraph more than 600 points")

    return <ScrollLine options={options} dataSet={dataSet} minWidth={530} />
  }
}
DataGraph = withStyles(Styles)(DataGraph)
export default withTheme()(DataGraph)



// WEBPACK FOOTER //
// ./src/pages/subscriptions/containers/data-graph.js